import { render, staticRenderFns } from "./TrainingDetails.vue?vue&type=template&id=d2d77ca2&scoped=true"
import script from "./TrainingDetails.vue?vue&type=script&lang=js"
export * from "./TrainingDetails.vue?vue&type=script&lang=js"
import style0 from "./TrainingDetails.vue?vue&type=style&index=0&id=d2d77ca2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d77ca2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2d77ca2')) {
      api.createRecord('d2d77ca2', component.options)
    } else {
      api.reload('d2d77ca2', component.options)
    }
    module.hot.accept("./TrainingDetails.vue?vue&type=template&id=d2d77ca2&scoped=true", function () {
      api.rerender('d2d77ca2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/trainingHistory/TrainingDetails.vue"
export default component.exports